import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { AuthContext } from '../../context/auth-context'

const Home = () => {
	const auth = useContext(AuthContext)
	//console.log('auth: ' + JSON.stringify(auth))

	let page

	if (auth.isLoggedIn) {
		//console.log('User is logged in!')
		page = '/admin/leagues/current'
	} else {
		//console.log('User is NOT logged in!')
		page = '/admin/login'
	}
	//
	//
	//
	//
	return (
		<ul>
			<li>
				<NavLink to={'/statsandstandings'}>STANDINGS</NavLink>
			</li>
			<li>
				<NavLink to={'/schedule'}>SCHEDULE</NavLink>
			</li>
			<li>
				<NavLink to={page}>ADMIN</NavLink>
			</li>
		</ul>
	)
}

export default Home
